/**
 * @generated SignedSource<<7ae0374b9bf6b2dde98826c9d9886b0d>>
 * @relayHash 9617757fd3b30479b16b9b195e99b42f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d890a7d92c3e2c38a2338e0208973b3022c4c13a04c7001aeda9e1597d60af1c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphQLDateFormat = "GLOBAL" | "MILLIS" | "USER" | "USER_FRIENDLY" | "%future added value";
export type EditorContentUnifiedQuery$variables = {
  cloudId: string;
  contentId: string;
  contentStateLastUpdatedFormat?: GraphQLDateFormat | null;
  draftShareId?: string | null;
  includeClassification?: boolean | null;
  includeCollaborators?: boolean | null;
  includeContentStateApprovals?: boolean | null;
  includeContentStateLastUpdated?: boolean | null;
  includeDevDocsAncestors?: boolean | null;
  isContentStateDraft?: boolean | null;
  isLivePage: boolean;
  status?: ReadonlyArray<string | null> | null;
  useClassificationLevelV2?: boolean | null;
  versionOverride?: number | null;
};
export type EditorContentUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentAppearanceFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useContentAppearanceFragment_content">;
      };
      readonly contentModeFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useContentModeFragment_content">;
      };
      readonly contentTypesHeaderFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useEditorContentTypesHeaderFragment_content">;
      };
      readonly coverPictureFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useCoverPictureFragment_content">;
      };
      readonly devDocsAncestorsFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"useDevDocsAncestorsFragment_content">;
      } | null;
      readonly editorByLineFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useEditorByLineFragment_content">;
      };
      readonly editorCollaboratorsFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"useEditorCollaboratorsFragment_content">;
      } | null;
      readonly editorContentStateFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useEditorContentStateFragment_content">;
      };
      readonly editorSpaceDetailFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useEditorSpaceDetailFragment_content">;
      };
      readonly emojiEverSetPropertyFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useEmojiEverSetPropertyFragment_content">;
      };
      readonly emojiTitleFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useEmojiTitleFragment_content">;
      };
      readonly favouriteContentFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useFavouriteContentFragment_content">;
      };
      readonly labelsFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useLabelsFragment_content">;
      };
      readonly migratedRecentlyFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useMigratedRecentlyFragment_content">;
      };
      readonly nativeCollabFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useNativeCollabFragment_content">;
      };
      readonly shareAndRestrictButtonFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useShareAndRestrictButtonFragment_content">;
      };
      readonly smartCreateFeedbackBannerFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useSmartCreateFeedbackBannerFragment_content">;
      };
      readonly titleContentPropertiesFragment: {
        readonly " $fragmentSpreads": FragmentRefs<"useTitleContentPropertiesFragment_content">;
      };
    } | null> | null;
  } | null;
  readonly editorAttachmentDownloadPolicyFragment: {
    readonly " $fragmentSpreads": FragmentRefs<"useEditorAttachmentDownloadPolicyFragment_query">;
  };
  readonly editorAvailableContentStatesFragment: {
    readonly " $fragmentSpreads": FragmentRefs<"useEditorContentStateFragment_query">;
  };
  readonly editorByLineContributorsFragment: {
    readonly " $fragmentSpreads": FragmentRefs<"useEditorByLineFragment_query">;
  };
  readonly editorCollaboratorsListFragment?: {
    readonly " $fragmentSpreads": FragmentRefs<"useEditorCollaboratorsFragment_query">;
  } | null;
  readonly shareAndRestrictButtonPublicLinkFragment: {
    readonly " $fragmentSpreads": FragmentRefs<"useShareAndRestrictButtonFragment_query">;
  };
};
export type EditorContentUnifiedQuery = {
  response: EditorContentUnifiedQuery$data;
  variables: EditorContentUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": "USER_FRIENDLY",
  "kind": "LocalArgument",
  "name": "contentStateLastUpdatedFormat"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "draftShareId"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeClassification"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeCollaborators"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentStateApprovals"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeContentStateLastUpdated"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDevDocsAncestors"
},
v9 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "isContentStateDraft"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLivePage"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useClassificationLevelV2"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v14 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v15 = [
  {
    "kind": "Variable",
    "name": "draftShareId",
    "variableName": "draftShareId"
  },
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v16 = {
  "kind": "Variable",
  "name": "isDraft",
  "variableName": "isContentStateDraft"
},
v17 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v18 = [
  (v17/*: any*/)
],
v19 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v20 = {
  "kind": "ScalarField",
  "name": "id"
},
v21 = {
  "kind": "ScalarField",
  "name": "title"
},
v22 = {
  "kind": "ScalarField",
  "name": "name"
},
v23 = {
  "kind": "ScalarField",
  "name": "key"
},
v24 = {
  "kind": "ScalarField",
  "name": "type"
},
v25 = [
  {
    "kind": "ScalarField",
    "name": "path"
  }
],
v26 = {
  "kind": "ScalarField",
  "name": "subType"
},
v27 = {
  "kind": "ScalarField",
  "name": "status"
},
v28 = {
  "kind": "ScalarField",
  "name": "value"
},
v29 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v30 = {
  "kind": "ScalarField",
  "name": "number"
},
v31 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v32 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v33 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v34 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    (v34/*: any*/)
  ],
  "type": "KnownUser"
},
v36 = {
  "kind": "ScalarField",
  "name": "when"
},
v37 = [
  (v32/*: any*/),
  (v33/*: any*/)
],
v38 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v20/*: any*/),
      (v23/*: any*/),
      (v28/*: any*/),
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          (v30/*: any*/)
        ]
      }
    ]
  }
],
v39 = {
  "kind": "ScalarField",
  "name": "generatedBy"
},
v40 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v41 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v20/*: any*/),
      (v23/*: any*/),
      (v28/*: any*/)
    ]
  }
],
v42 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": (v25/*: any*/)
},
v43 = [
  (v32/*: any*/),
  (v33/*: any*/),
  (v35/*: any*/),
  (v42/*: any*/)
],
v44 = {
  "kind": "ScalarField",
  "name": "count"
},
v45 = {
  "kind": "ScalarField",
  "name": "color"
},
v46 = {
  "kind": "ScalarField",
  "name": "restrictionLevel"
},
v47 = [
  (v20/*: any*/),
  {
    "kind": "ScalarField",
    "name": "guideline"
  },
  {
    "kind": "ScalarField",
    "name": "guidelineADF"
  },
  {
    "kind": "ScalarField",
    "name": "description"
  },
  (v45/*: any*/),
  (v22/*: any*/),
  (v27/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditorContentUnifiedQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useEditorContentTypesHeaderFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentTypesHeaderFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useEmojiTitleFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "emojiTitleFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useEmojiEverSetPropertyFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "emojiEverSetPropertyFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useContentAppearanceFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentAppearanceFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useCoverPictureFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "coverPictureFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useTitleContentPropertiesFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "titleContentPropertiesFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "isLivePage",
                          "variableName": "isLivePage"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "useContentModeFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentModeFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useShareAndRestrictButtonFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "shareAndRestrictButtonFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useEditorSpaceDetailFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "editorSpaceDetailFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useNativeCollabFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "nativeCollabFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useLabelsFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "labelsFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useSmartCreateFeedbackBannerFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "smartCreateFeedbackBannerFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useFavouriteContentFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "favouriteContentFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useMigratedRecentlyFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "migratedRecentlyFragment"
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "includeClassification",
                          "variableName": "includeClassification"
                        },
                        {
                          "kind": "Variable",
                          "name": "useClassificationLevelV2",
                          "variableName": "useClassificationLevelV2"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "useEditorByLineFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "editorByLineFragment"
              },
              {
                "condition": "includeDevDocsAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "useDevDocsAncestorsFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "devDocsAncestorsFragment"
                  }
                ]
              },
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "includeApprovals",
                          "variableName": "includeContentStateApprovals"
                        },
                        {
                          "kind": "Variable",
                          "name": "includeLastUpdated",
                          "variableName": "includeContentStateLastUpdated"
                        },
                        (v16/*: any*/),
                        {
                          "kind": "Variable",
                          "name": "lastUpdatedFormat",
                          "variableName": "contentStateLastUpdatedFormat"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "useEditorContentStateFragment_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "editorContentStateFragment"
              },
              {
                "condition": "includeCollaborators",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "useEditorCollaboratorsFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "editorCollaboratorsFragment"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": (v18/*: any*/),
              "kind": "FragmentSpread",
              "name": "useShareAndRestrictButtonFragment_query"
            }
          ],
          "type": "Query"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "shareAndRestrictButtonPublicLinkFragment"
      },
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": (v18/*: any*/),
              "kind": "FragmentSpread",
              "name": "useEditorByLineFragment_query"
            }
          ],
          "type": "Query"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "editorByLineContributorsFragment"
      },
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": (v18/*: any*/),
              "kind": "FragmentSpread",
              "name": "useEditorContentStateFragment_query"
            }
          ],
          "type": "Query"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "editorAvailableContentStatesFragment"
      },
      {
        "condition": "includeCollaborators",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    (v19/*: any*/),
                    (v17/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "useEditorCollaboratorsFragment_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "editorCollaboratorsListFragment"
          }
        ]
      },
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": (v18/*: any*/),
              "kind": "FragmentSpread",
              "name": "useEditorAttachmentDownloadPolicyFragment_query"
            }
          ],
          "type": "Query"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "editorAttachmentDownloadPolicyFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v13/*: any*/),
      (v3/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v12/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditorContentUnifiedQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "operation"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetType"
                  }
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "alias"
                  },
                  (v24/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                  },
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v24/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": (v25/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "homepageId"
                  }
                ]
              },
              (v24/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "alias": "smartFolderProperties",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "keys",
                    "value": [
                      "smartFolderProperties"
                    ]
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JsonContentProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v23/*: any*/),
                      (v28/*: any*/)
                    ]
                  }
                ],
                "storageKey": "properties(keys:[\"smartFolderProperties\"])"
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v24/*: any*/),
                      (v35/*: any*/)
                    ]
                  },
                  (v36/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "ncsStepVersion"
                  }
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": (v37/*: any*/)
                  },
                  (v36/*: any*/)
                ]
              },
              {
                "alias": "emojiTitlePublished",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "emoji-title-published"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": "properties(key:\"emoji-title-published\")"
              },
              {
                "alias": "emojiTitleDraft",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "emoji-title-draft"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": "properties(key:\"emoji-title-draft\")"
              },
              {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "PublishedContentProperties",
                    "kind": "LinkedField",
                    "name": "latest",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "defaultTitleEmoji"
                      },
                      (v39/*: any*/)
                    ]
                  },
                  {
                    "condition": "isLivePage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "PublishedContentProperties",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": (v40/*: any*/)
                      }
                    ]
                  },
                  {
                    "condition": "isLivePage",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "concreteType": "DraftContentProperties",
                        "kind": "LinkedField",
                        "name": "draft",
                        "plural": false,
                        "selections": (v40/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "DraftContentProperties",
                    "kind": "LinkedField",
                    "name": "draft",
                    "plural": false,
                    "selections": [
                      (v39/*: any*/)
                    ]
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "emoji-ever-set"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v41/*: any*/),
                "storageKey": "properties(key:\"emoji-ever-set\")"
              },
              {
                "alias": "appearanceDraft",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "content-appearance-draft"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": "properties(key:\"content-appearance-draft\")"
              },
              {
                "alias": "coverPictureProperties",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "keys",
                    "value": [
                      "cover-picture-id-draft",
                      "cover-picture-id-published"
                    ]
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
              },
              {
                "alias": "pageTitlePublished",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "page-title-property-published"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": "properties(key:\"page-title-property-published\")"
              },
              {
                "alias": "pageTitleDraft",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "page-title-property-draft"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": "properties(key:\"page-title-property-draft\")"
              },
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                    "kind": "LinkedField",
                    "name": "frontend",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "coverPictureWidth"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "migratedRecently"
                      }
                    ]
                  },
                  {
                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                    "kind": "LinkedField",
                    "name": "currentuser",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isFavourite"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
              },
              {
                "kind": "ScalarField",
                "name": "hasRestrictions"
              },
              {
                "kind": "ScalarField",
                "name": "hasViewRestrictions"
              },
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v43/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "createdDate"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v43/*: any*/)
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": {
                      "direction": "ASCENDING",
                      "sortField": "LABELLING_CREATIONDATE"
                    }
                  }
                ],
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v22/*: any*/)
                    ]
                  },
                  (v44/*: any*/)
                ],
                "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
              },
              {
                "kind": "ScalarField",
                "name": "creatorId"
              },
              {
                "args": [
                  (v16/*: any*/)
                ],
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "contentState",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v22/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isCallerPermitted"
                  },
                  {
                    "condition": "includeContentStateApprovals",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "lastModifierAaid"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "useClassificationLevelV2",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": (v47/*: any*/)
                          }
                        ]
                      },
                      {
                        "condition": "useClassificationLevelV2",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevelV2",
                            "plural": false,
                            "selections": (v47/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "featureEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "source"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isReclassificationPermitted"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canManageSpaceSettings"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "classificationControlSetting"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "userOverrideSetting"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeDevDocsAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "ancestors",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v24/*: any*/),
                      (v26/*: any*/),
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v37/*: any*/)
                          }
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                              "devdocsProperties",
                              "smartFolderProperties"
                            ]
                          }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": (v41/*: any*/),
                        "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeContentStateLastUpdated",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "format",
                        "variableName": "contentStateLastUpdatedFormat"
                      },
                      (v16/*: any*/)
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "includeCollaborators",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "SpaceUserMetadata",
                        "kind": "LinkedField",
                        "name": "currentUser",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
          }
        ],
        "concreteType": "PublicLinkPage",
        "kind": "LinkedField",
        "name": "publicLinkPage",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "pageId"
          },
          {
            "kind": "ScalarField",
            "name": "pageStatus"
          },
          {
            "kind": "ScalarField",
            "name": "accessType"
          }
        ]
      },
      {
        "args": [
          (v14/*: any*/),
          {
            "kind": "Literal",
            "name": "limit",
            "value": 4
          }
        ],
        "concreteType": "ContentContributors",
        "kind": "LinkedField",
        "name": "contentContributors",
        "plural": false,
        "selections": [
          (v44/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isOwnerContributor"
          }
        ]
      },
      {
        "args": (v18/*: any*/),
        "concreteType": "AvailableContentStates",
        "kind": "LinkedField",
        "name": "availableContentStates",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "customContentStates",
            "plural": true,
            "selections": [
              (v22/*: any*/),
              (v45/*: any*/),
              (v20/*: any*/)
            ]
          },
          {
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "spaceContentStates",
            "plural": true,
            "selections": [
              (v22/*: any*/),
              (v45/*: any*/),
              (v20/*: any*/),
              (v46/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "Confluence_dataSecurityPolicy",
        "kind": "LinkedField",
        "name": "dataSecurityPolicy",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "ATTACHMENT_DOWNLOAD"
              },
              (v17/*: any*/),
              {
                "kind": "Literal",
                "name": "contentStatus",
                "value": "CURRENT"
              },
              {
                "kind": "Literal",
                "name": "contentVersion",
                "value": 1
              }
            ],
            "concreteType": "DataSecurityPolicyDecision",
            "kind": "LinkedField",
            "name": "isActionEnabledForContent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "action"
              },
              {
                "kind": "ScalarField",
                "name": "allowed"
              }
            ]
          }
        ]
      },
      {
        "condition": "includeCollaborators",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v19/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 2147483647
              },
              (v14/*: any*/)
            ],
            "concreteType": "ConfluenceCollaboratorConnection",
            "kind": "LinkedField",
            "name": "confluence_contentCollaborators",
            "plural": false,
            "selections": [
              (v44/*: any*/),
              {
                "concreteType": "ConfluenceCollaborator",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "person",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v24/*: any*/),
                      (v33/*: any*/),
                      (v42/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v34/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "jobTitle"
                          }
                        ],
                        "type": "KnownUser"
                      }
                    ]
                  },
                  {
                    "concreteType": "ConfluenceAgent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v42/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9617757fd3b30479b16b9b195e99b42f",
    "id": "d890a7d92c3e2c38a2338e0208973b3022c4c13a04c7001aeda9e1597d60af1c",
    "metadata": {},
    "name": "EditorContentUnifiedQuery",
    "operationKind": "query",
    "text": "query EditorContentUnifiedQuery($contentId:ID!,$cloudId:ID!,$versionOverride:Int,$draftShareId:String,$status:[String],$isLivePage:Boolean!,$includeClassification:Boolean=false,$useClassificationLevelV2:Boolean=false,$includeDevDocsAncestors:Boolean=false,$isContentStateDraft:Boolean=true,$includeContentStateApprovals:Boolean=false,$includeContentStateLastUpdated:Boolean=false,$contentStateLastUpdatedFormat:GraphQLDateFormat=USER_FRIENDLY,$includeCollaborators:Boolean=false){content(id:$contentId,version:$versionOverride,draftShareId:$draftShareId,status:$status){nodes{...useEditorContentTypesHeaderFragment_content,...useEmojiTitleFragment_content,...useEmojiEverSetPropertyFragment_content,...useContentAppearanceFragment_content,...useCoverPictureFragment_content,...useTitleContentPropertiesFragment_content,...useContentModeFragment_content_2xAkZ6,...useShareAndRestrictButtonFragment_content,...useEditorSpaceDetailFragment_content,...useNativeCollabFragment_content,...useLabelsFragment_content,...useSmartCreateFeedbackBannerFragment_content,...useFavouriteContentFragment_content,...useMigratedRecentlyFragment_content,...useEditorByLineFragment_content_hx45J,...useDevDocsAncestorsFragment_content@include(if:$includeDevDocsAncestors),...useEditorContentStateFragment_content_17amu1,...useEditorCollaboratorsFragment_content@include(if:$includeCollaborators),id}},...useShareAndRestrictButtonFragment_query_3SK5LQ,...useEditorByLineFragment_query_3SK5LQ,...useEditorContentStateFragment_query_3SK5LQ,...useEditorCollaboratorsFragment_query_1d0jrk@include(if:$includeCollaborators),...useEditorAttachmentDownloadPolicyFragment_query_3SK5LQ}fragment BylineClassification_content_4MZOe on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content_4MZOe}fragment SpaceDetail_space on Space{id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}fragment useContentAppearanceFragment_content on Content{id,appearanceDraft:properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}}}fragment useContentClassification_content_4MZOe on Content{id,classificationLevelDetails{classificationLevel@skip(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},classificationLevelV2@include(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useContentModeFragment_content_2xAkZ6 on Content{id,contentProperties{latest@include(if:$isLivePage){contentMode},draft@skip(if:$isLivePage){contentMode}}}fragment useCoverPictureFragment_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment useDevDocsAncestorsFragment_content on Content{id,ancestors{id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}}}fragment useEditorAttachmentDownloadPolicyFragment_query_3SK5LQ on Query{dataSecurityPolicy{isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,contentVersion:1){action,allowed}}}fragment useEditorByLineFragment_content_hx45J on Content{id,type,history{createdBy{__typename,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,displayName,...on KnownUser{accountId},profilePicture{path}}},version{number,when},contentProperties{latest{generatedBy}},space{id,name},...BylineClassification_content_4MZOe@include(if:$includeClassification)}fragment useEditorByLineFragment_query_3SK5LQ on Query{contentContributors(id:$contentId,limit:4){count,isOwnerContributor}}fragment useEditorCollaboratorsFragment_content on Content{id,status,space{id,currentUser{isAdmin}}}fragment useEditorCollaboratorsFragment_query_1d0jrk on Query{confluence_contentCollaborators(cloudId:$cloudId,id:$contentId,first:2147483647){count,nodes{person{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,jobTitle}},agent{displayName,accountId,profilePicture{path}}}}}fragment useEditorContentStateFragment_content_17amu1 on Content{id,contentState(isDraft:$isContentStateDraft){id,name,color,restrictionLevel,isCallerPermitted,lastModifierAaid@include(if:$includeContentStateApprovals)},contentStateLastUpdated(format:$contentStateLastUpdatedFormat,isDraft:$isContentStateDraft)@include(if:$includeContentStateLastUpdated){value}}fragment useEditorContentStateFragment_query_3SK5LQ on Query{availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}fragment useEditorContentTypesHeaderFragment_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment useEditorSpaceDetailFragment_content on Content{space{id,key,alias,...SpaceDetail_space}}fragment useEmojiEverSetPropertyFragment_content on Content{id,properties(key:\"emoji-ever-set\"){nodes{id,key,value}}}fragment useEmojiTitleFragment_content on Content{id,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}fragment useFavouriteContentFragment_content on Content{id,type,metadata{currentuser{favourited{isFavourite}}},operations{operation,targetType}}fragment useLabelsFragment_content on Content{id,labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count}}fragment useMigratedRecentlyFragment_content on Content{id,metadata{frontend{migratedRecently}}}fragment useNativeCollabFragment_content on Content{id,type,status,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},history{createdBy{__typename,displayName},createdDate},space{id,name,homepageId},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){nodes{id,name}},subType}fragment useShareAndRestrictButtonFragment_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useShareAndRestrictButtonFragment_query_3SK5LQ on Query{publicLinkPage(pageId:$contentId){pageId,pageStatus,accessType}}fragment useSmartCreateFeedbackBannerFragment_content on Content{title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}fragment useTitleContentPropertiesFragment_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
  }
};
})();

(node as any).hash = "dad9bc09449da9ff5d2cf996d2966abe";

export default node;
